import Price from '~/utils/Price/Price';

export default class CalculatedPrice {
	type: string;

	description: string;

	sourceCurrencyPrice: Price;

	targetCurrencyPrice: Price;

	constructor(type: string, description: string, sourceCurrencyPrice: Price, targetCurrencyPrice: Price) {
		this.type = type;
		this.description = description;
		this.sourceCurrencyPrice = sourceCurrencyPrice;
		this.targetCurrencyPrice = targetCurrencyPrice;
	}
}
